import React, { useState } from "react";
import { Row, Col, Menu, Breadcrumb, Typography } from "antd";
import {
  UserOutlined,
  LockOutlined,
  BellOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import PageRoutes from "../../../utils/routes";
import PersonnelInfo from "./Components/PersonalInfo";
import ChangePassword from "./Components/ChangePassord";
import SMSNotifications from "./Components/SmsNotifications";
import usePersonnelInfoService from "../../../services/usePersonnelInfoService";

const { Title } = Typography;

const menuItems = [
  { key: "personal", icon: <UserOutlined />, label: "Kişisel Bilgiler" },
  { key: "password", icon: <LockOutlined />, label: "Şifreyi Değiştir" },
  { key: "notifications", icon: <BellOutlined />, label: "SMS Bildirimleri" },
  //   {
  //     key: "account",
  //     icon: <DeleteOutlined />,
  //     label: "Hesap Silme ve Dondurma",
  //   },
];

// const DeleteAccount = () => (
//   <div>
//     <Typography.Paragraph>
//       Hesabınızı silmek veya dondurmak için aşağıdaki düğmeleri kullanın. Bu
//       işlem geri alınamaz.
//     </Typography.Paragraph>
//     <Button danger>Hesabı Dondur</Button>
//     <Button type="primary" danger style={{ marginLeft: 8 }}>
//       Hesabı Sil
//     </Button>
//   </div>
// );

export default function Component() {
  const [selectedMenu, setSelectedMenu] = useState("personal");
  const { useGetPersonnelInfo } = usePersonnelInfoService();
  const { data: personnelInfo } = useGetPersonnelInfo();
  const renderContent = () => {
    switch (selectedMenu) {
      case "personal":
        return <PersonnelInfo personnelInfo={personnelInfo.data} />;
      case "password":
        return <ChangePassword />;
      case "notifications":
        return <SMSNotifications />;
      //   case "account":
      //     return <DeleteAccount />;
      default:
        return <PersonnelInfo />;
    }
  };

  return (
    <div style={{ padding: "24px" }}>
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item>
          <NavLink to={PageRoutes.personnelHome}> Hesabım</NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Hesap Ayarları</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={24}>
        <Col md={6} xs={24}>
          <Menu
            mode="vertical"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => setSelectedMenu(key)}
            style={{
              width: "100%",
              borderRight: "1px solid #f0f0f0",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "4px",
            }}
            items={menuItems}
          />
        </Col>
        <Col md={18} xs={24}>
          <div
            style={{
              background: "#fff",
              padding: 24,
              minHeight: 280,
              borderRadius: "4px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}>
            <Title level={3} style={{ marginBottom: 20 }}>
              {menuItems.find((item) => item.key === selectedMenu)?.label}
            </Title>
            {renderContent()}
          </div>
        </Col>
      </Row>
    </div>
  );
}
